module.exports = __webpack_public_path__ + "static/media/message.a0bf03a9.svg";